import React, { useEffect, useRef } from "react"
import { Paper } from "@material-ui/core"
import useASTStore from "../../../utils/AST-store" // <-- import your zustand store
import { useStyleSheet } from "../../../../utils/use-style-sheet"

/**
 * @param props {{
 *  solFiles: { path: string, content: string }[],
 *  selectedFile: string,
 *  setSelectedFile?: (path: string) => void
 * }}
 */
export default function FileContentViewer({ solFiles, selectedFile, setSelectedFile }) {
  // Find the selected file's content
  const sol = solFiles.find(x => x.path === selectedFile)?.content || ""
  // Split into lines, but do NOT collapse or trim spaces
  const lines = sol.split('\n')

  const ref = useRef(null)
  const gotoResource = useASTStore((state) => state.gotoResource)
  const scrollIntoView = useASTStore((state) => state.scrollIntoView)

  // Highlight and scroll to line if needed
  function clickItem(evt) {
    const item = evt.target
    const gotoFile = item.getAttribute('goto_file')
    const gotoLine = item.getAttribute('goto_line')
    const gotoTab = item.getAttribute('goto_tab')
    const gotoAstId = item.getAttribute('ast_id')
    if (gotoFile && setSelectedFile) {
      setSelectedFile(gotoFile)
    }
    if (gotoLine) {
      setTimeout(() => {
        const elm = document.querySelector(`[data-line="${gotoLine}"]`)
        if (elm) {
          (elm instanceof HTMLElement) && (elm.style.border = '1px solid yellow')
          setTimeout(() => {
            (elm instanceof HTMLElement) && (elm.style.border = '')
          }, 2000)
          scrollIntoView(elm)
        }
      })
    }
    if (gotoTab) {
      gotoResource(gotoTab, gotoAstId)
    }
  }

  useEffect(() => {
    document.body.addEventListener('click', clickItem)
    return () => document.body.removeEventListener('click', clickItem)
    // eslint-disable-next-line
  }, [])

  useStyleSheet(`
    .code *{
    display:inline
  }`)

  return (
    <Paper
      ref={ref}
      style={{
        fontFamily: "Fira Mono, Menlo, Monaco, Consolas, monospace",
        fontSize: 15,
        background: "#222336",
        color: "#f8f8f2",
        padding: 0,
        margin: 0,
        overflow: "auto",
        borderRadius: 10,
        maxHeight: "70vh",
        minHeight: 200,
        width: "100%",
        boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
      }}
      elevation={3}
    >
      <div style={{ width: "100%" }}>
        {lines.map((line, index) => (
          <div
            data-line={index + 1}
            key={index + 1}
            style={{
              display: "flex",
              alignItems: "flex-start",
              minHeight: 22,
              borderBottom: "1px solid rgba(255,255,255,0.03)",
              transition: "background 0.2s",
              background: index % 2 === 0 ? "rgba(255,255,255,0.01)" : "rgba(0,0,0,0.08)",
              padding: "0 0.5rem",
            }}
          >
            <div
              style={{
                width: 40,
                minWidth: 40,
                textAlign: "right",
                marginRight: 15,
                userSelect: "none",
                color: "#888",
                background: "rgba(0,0,0,0.10)",
                padding: "0 4px",
                borderRight: "1px solid #333",
                fontSize: 13,
                lineHeight: "22px",
                letterSpacing: "0.5px",
              }}
            >
              {index + 1}
            </div>
            <div
              className="code"
              style={{
                flex: 1,
                whiteSpace: "pre", // preserve all spaces and tabs
                wordBreak: "break-word",
                padding: "2px 0",
                margin: 0,
                background: "transparent",
                color: "#f8f8f2",
                fontFamily: "inherit",
                fontSize: 15,
                lineHeight: "22px",
                tabSize: 2,
              }}
              dangerouslySetInnerHTML={{ __html: line === "" ? "&nbsp;" : line }}
            />
          </div>
        ))}
      </div>
    </Paper>
  )
}